// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    merchantPaymentFormSchema,
    MerchantPaymentValuesType,
    merchantPaymentInitialValues,
} from "../_formTypes";
import {
    useGetPayment3DTrxSettingsList,
    useGetAcquirerBankList,
    GetMerchantPaymentRequest,
    useGetMerchantPaymentV2,
    useGetMerchantPayment,
    useCancelPaymentAndTransaction,
    CancelPaymentAndTransactionRequest,
    useRefundPaymentAndTransaction,
    RefundPaymentAndTransactionRequest,
    useGetTrxStatusSettingsList,
    BasePagingResponse,
    PagingResponse,
    useAuthorization,
    useGetAllMerchantList,
    useSendMoney,
    useSendMoneyV2,
    useGetMerchantsWithParentMerchant,
    useGetListSettlementsPaymentBalance,
} from "../../../../hooks";
import {
    GridColDef,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
    FormControl,
    Link,
    Box,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Checkbox,
    Skeleton
} from "@mui/material";
import { Button, Loading } from "../../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
    DateTimePickerControl,
    Table,
    DeleteConfirmModal,
    InputControl,
    NumericFormatInputControl,
    MechantPaymentModal,
    DatePickerControl,
    createBooleanOperator,
    TextAreaInputControl
} from "../../../molecules";
import { useSetSnackBar } from "../../../../store/Snackbar.state";
import { downloadExcel } from "../../../../util/downloadExcel";
import { useUserInfo } from "../../../../store/User.state";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

export const MerchantEndOfDayComponentWithBalance = () => {
    const theme = useTheme();
    const user = useLocation().state as unknown as IUser | undefined;
    const { showDelete, showUpdate } = useAuthorization();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [queryOptions, setQueryOptions] = React.useState({});
    const { control, handleSubmit, setValue, getValues } =
        useForm<MerchantPaymentValuesType>({
            resolver: zodResolver(merchantPaymentFormSchema),
            defaultValues: merchantPaymentInitialValues,
        });
    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 25,
    });
    const [tableselectedRow, setTableSelectedRow] = useState({} as any);
    const { mutate: GetMerchantPayment, isLoading: isGetMerchantPaymentLoading } =
        useGetMerchantPaymentV2();
    const { mutate: sendMoney, isLoading: isGetSendMoneyLoading } =
        useSendMoneyV2();
    const setSnackbar = useSetSnackBar();
    // const { data: rawMerchantList } = useGetAllMerchantList("ACTIVE");
    const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant();
    const [userInfo] = useUserInfo();
    useEffect(() => {
        const currentDate = dayjs();
        setValue("startPaymentMerchantDate", currentDate);
        setValue("endPaymentMerchantDate", currentDate);
    }, [setValue]);
    const [openDialog, setOpenDialog] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const [shouldRefresh, setShouldRefresh] = React.useState(false);
    const [selectedMerchant, setSelectedMerchant] = useState(
        user
            ? Number(userInfo.merchantId) !== 0
                ? { label: userInfo.merchantName, value: Number(userInfo.merchantId) }
                : null
            : null
    );

    const [paymentMode, setPaymentMode] = useState<'selected' | 'page'>('selected');

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmPay = () => {
        if (paymentMode === 'page') {
            handlePayCurrentPage();
        } else {
            handleBulkPay();
        }
        setOpenDialog(false);
    };

    const merchantList = useMemo(() => {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number, isPayoutBlocked: boolean }) => {

                var getLabel = (rawPosType?.isPayoutBlocked ?? false) ? ' ( Ödeme Blokeli )' : '';

                return {
                    label: rawPosType.merchantName + getLabel,
                    value: rawPosType.merchantId,
                    isPayoutBlocked: rawPosType?.isPayoutBlocked ?? false
                };
            }
        );
    }, [rawMerchantList?.data]);


    const [formValues, setFormValues] =
        useState<MerchantPaymentValuesType | null>(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const onSubmit = (data: MerchantPaymentValuesType) => {
        setTableData(undefined);
        setShowTable(true)
        const actualMerchantId = data.merchantId || +userInfo?.merchantId;

        const filterMerchantId = data.filterMerchantId ? Array.isArray(data.filterMerchantId) ? data.filterMerchantId : [data.filterMerchantId] : [];

        const req: GetMerchantPaymentRequest = {
            page: paginationModel.page,
            size: paginationModel.pageSize,
            orderByDesc: true,
            orderBy: "CreateDate",
            status: data.status,
            merchantId: filterMerchantId,

            startPaymentMerchantDate: data?.startPaymentMerchantDate
                ? dayjs(data.startPaymentMerchantDate).format("YYYY-MM-DD")
                : "",
            endPaymentMerchantDate: data?.endPaymentMerchantDate ? dayjs(data.endPaymentMerchantDate).format("YYYY-MM-DD") : "",
            paymentFlag: data.paymentFlag,
        };

        if (data?.startDate) {
            req.startDate = dayjs(
                data.startDate
            ).format("YYYY-MM-DD");
        }

        if (data?.endDate) {
            req.endDate = dayjs(data.endDate).format(
                "YYYY-MM-DD"
            );
        }

        setFormValues(req);
        setIsSubmitted(true);
    };
    useEffect(() => {
        if (!isSubmitted || formValues == null) {
            return;
        }
        const requestPayload = {
            ...formValues,
            ...getQueryParams(queryOptions),
        };

        if (queryOptions?.field && queryOptions?.value !== undefined) {
            requestPayload[queryOptions.field] = queryOptions.value;
        }

        // Parallel Fetch for Balance
        const balanceReq = {
            merchantId: requestPayload.merchantId,
            startPaymentMerchantDate: requestPayload.startPaymentMerchantDate,
            endPaymentMerchantDate: requestPayload.endPaymentMerchantDate
        };

        GetMerchantPayment(requestPayload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    console.log(data.data);
                    setTableData(data.data);
                    getBalance(data.data);
                } else {
                    setTableData(data.data);
                    getBalance(data.data);
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    }, [formValues, isSubmitted, queryOptions, shouldRefresh]);

    const PayButton = ({ rowData, sendMoney, control, getValues, currency }) => {
        const [dialogOpen, setDialogOpen] = useState(false);
        const [localPaymentAmount, setLocalPaymentAmount] = useState(null);
        const [isValid, setIsValid] = useState(true);
        const [errorDialogOpen, setErrorDialogOpen] = useState(false);
        const [errorDetails, setErrorDetails] = useState<any>(null);

        const [paymentDescription, setPaymentDescription] = useState(null);

        // TRY kontrolü
        const displayCurrency = currency === 'TRY' ? 'TL' : currency;
        const handleOpen = () => {
            if (localPaymentAmount === null) {
                setLocalPaymentAmount(rowData.paymentAmountBalance);
            }
            setDialogOpen(true);
        };

        const handleClose = () => {
            setDialogOpen(false);
            setLocalPaymentAmount(null);
        };

        const handlePay = () => {
            const paymentAmount = getValues("paymentAmount");

            if (!localPaymentAmount || localPaymentAmount <= 0) {
                setIsValid(false);
                setSnackbar({
                    severity: "error",
                    description: "Ödeme miktarı 0 veya boş olamaz",
                    isOpen: true,
                });
                return;
            }

            const requestData: IVakifBankSendMoneyRequest = {
                merchantId: rowData.merchantId,
                merchantName: rowData.accountOwner,
                iban: rowData.iban,
                bankCode: rowData.bankCode,
                paymentAmount: +localPaymentAmount,
                currencyCode: +rowData.currency,
                identityNumber: rowData.taxNumber,
                endOfDayDate: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS"),
                transactionId: uuidv4(),
                paymentDescription: document.getElementById('paymentDescription')?.value ?? null
            };

            console.log('end of day request data', requestData);

            sendMoney([requestData], {
                onSuccess: (data) => {
                    const resultItem = data?.data?.data?.[0];
                    if (resultItem) {
                        if (resultItem.isSuccess) {
                            setSnackbar({
                                severity: "success",
                                isOpen: true,
                                description: resultItem.statusCodeDesc,
                            });
                            setShouldRefresh((prev) => !prev);
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: resultItem.statusCodeDesc,
                                isOpen: true,
                            });
                            setErrorDetails(resultItem);
                            setErrorDialogOpen(true);
                        }
                    } else {
                        if (data.isSuccess) {
                            setSnackbar({
                                severity: "success",
                                isOpen: true,
                                description: data?.message ?? "İşlem başarıyla tamamlandı",
                            });
                            setShouldRefresh((prev) => !prev);
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: data?.message ?? "İşlem sırasında bir hata oluştu",
                                isOpen: true,
                            });
                        }
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            });

            handleClose();
        };

        return (
            <>
                <Button
                    text="Öde"
                    variant="text"
                    color="info"
                    sx={{ flex: 1, height: 20, py: 5 }}
                    onClick={handleOpen}
                >
                    Öde
                </Button>

                <Dialog open={dialogOpen} onClose={handleClose}>
                    <DialogTitle>Ödeme Miktarı</DialogTitle>
                    <DialogContent>
                        <FormControl sx={{ width: 290, mt: 3 }}>
                            <NumericFormatInputControl
                                sx={{ flex: 1 }}
                                label="Üye İşyeri Hak Ediş Tutarı"
                                control={control}
                                id="paymentAmount"
                                adornmentText={displayCurrency}
                                thousandSeparator="."
                                value={localPaymentAmount}
                                decimalSeparator=","
                                decimalScale={2}
                                fixedDecimalScale
                                onValueChange={(values) => {
                                    setLocalPaymentAmount(values.floatValue);
                                }}
                            />
                            <TextAreaInputControl
                                sx={{ marginTop: 2 }}
                                placeholder="Açıklama"
                                uniqueId="paymentDescription"
                                value={rowData.eftDescription}
                                disabled={(rowData.eftDescription != null && rowData.eftDescription != undefined && rowData.eftDescription != "" && rowData.eftDescription) ? true : false}
                            />
                            {(rowData.eftDescription != null && rowData.eftDescription != undefined && rowData.eftDescription != "" && rowData.eftDescription) && <Box sx={{
                                mt: 1,
                                fontSize: '13px',
                                color: 'text.secondary',
                                fontStyle: 'italic'
                            }}>
                                Not: Üye işyerine tanımlı bir EFT ödeme açıklaması bulunduğundan, bu açıklama değiştirilemez.
                            </Box>}
                        </FormControl>
                        {/* <FormControl sx={{ width: 290, mt: 3 }}>
                
              </FormControl> */}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handlePay}
                            color="primary"
                            text=" Ödemeyi Tamamla"
                            variant="contained"
                        >
                            Ödemeyi Tamamla
                        </Button>
                        <Button onClick={handleClose} color="primary" text="Iptal">
                            İptal
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={errorDialogOpen} onClose={() => setErrorDialogOpen(false)}>
                    <DialogTitle>Ödeme Sonucu</DialogTitle>
                    <DialogContent>
                        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1.5, minWidth: 320 }}>
                            <Box><strong>İşlem ID:</strong> {errorDetails?.islemId}</Box>
                            <Box><strong>Durum Açıklaması:</strong> {errorDetails?.statusCodeDesc}</Box>
                            <Box><strong>Hesap Sahibi:</strong> {errorDetails?.accountOwner}</Box>
                            <Box><strong>Tutar:</strong> {errorDetails?.amount?.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {displayCurrency}</Box>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setErrorDialogOpen(false)} color="primary" text="Kapat">
                            Kapat
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    };



    const processPayment = (rows) => {
        const bulkRequestData = rows.map((row) => {
            return {
                merchantId: row.merchantId,
                merchantName: row.accountOwner,
                iban: row.iban,
                bankCode: row.bankCode,
                paymentAmount: row.paymentAmountBalance,
                currencyCode: +row.currency,
                identityNumber: row.taxNumber,
                endOfDayDate: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS"),
                transactionId: uuidv4(),
                paymentDescription: document.getElementById('paymentDescriptionBulk')?.value ?? null
            };
        });

        if (bulkRequestData.length === 0) {
            setSnackbar({
                severity: "error",
                description: "Ödenecek uygun kayıt bulunamadı (Bakiyesi 0'dan büyük ve TRY olanlar).",
                isOpen: true,
            });
            return;
        }

        sendMoney(bulkRequestData, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                    setShouldRefresh((prev) => !prev);
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    }

    const handleBulkPay = () => {
        processPayment(selectedRows);
    };

    const handlePayCurrentPage = () => {
        const startIndex = paginationModel.page * paginationModel.pageSize;
        const endIndex = startIndex + paginationModel.pageSize;
        const pageRows = tableData?.result?.slice(startIndex, endIndex)?.filter(row => row.paymentAmountBalance > 0 && row.currencyDesc === 'TRY') || [];
        processPayment(pageRows);
    }

    function RenderActionButton(transaction: any) {
        const [isModalOpen, setIsModalOpen] = useState(false);

        const handleOpenModal = () => {
            setIsModalOpen(true);
        };

        const handleCloseModal = () => {
            setIsModalOpen(false);
        };
        return (
            <>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    text="Detay"
                    sx={{ flex: 1, height: 20, py: 4 }}
                ></Button>
                <MechantPaymentModal
                    transaction={transaction}
                    isOpen={isModalOpen}
                    handleClose={handleCloseModal}
                />
            </>
        );
    }

    const deleteRow = React.useCallback(
        (transaction: any) => () => {
            setTableSelectedRow(transaction);
        },
        []
    );
    const booleanOptions = [
        { label: "Evet", value: true },
        { label: "Hayır", value: "false" },
    ];
    const currencyDesc = [
        { label: "TRY", value: "TRY" },
        { label: "USD", value: "USD" },
        { label: "EUR", value: "EUR" }
    ];

    const columns: GridColDef[] = useMemo(() => {
        return [
            {
                field: "Aksiyonlar",
                type: "actions",
                width: 80,
                getActions: (params) => [
                    !!showDelete ? (
                        <GridActionsCellItem
                            // label="Sil"
                            // onClick={deleteRow(params.row)}
                            icon={RenderActionButton(params.row)}
                        />
                    ) : (
                        <></>
                    ),
                ],
            },

            {
                field: "payButton",
                headerName: "Öde",
                width: 150,
                renderCell: (params) => {
                    if (params.row.paymentAmountBalance > 0 && params.row.currencyDesc === 'TRY')
                        return <PayButton rowData={params.row} sendMoney={sendMoney} control={control} getValues={getValues} currency={params.row.currencyDesc} />;
                    else
                        return <></>
                },
            },
            {
                field: "merchantId",
                headerName: "Üye İşyeri Numarası",
                width: 180,
                resizable: true,
            },
            {
                field: "merchantName",
                headerName: "Üye İşyeri Adı",
                resizable: true,
                width: 300,
            },
            {
                field: "paymentMerchantDate",
                headerName: "Üye İşyeri Ödeme Tarihi",
                width: 200,
                renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                },
            },
            {
                field: "paidAmount",
                headerName: "Ödenen Tutar",
                type: "decimal",
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
            },
            {
                field: "paymentAmount",
                headerName: "Üye İşyeri FTP Hak Ediş Tutarı",
                type: "decimal",
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
            },
            {
                field: "paymentAmountBalance",
                headerName: "Üye İşyeri Cari Hak Ediş Tutarı",
                type: "decimal",
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
            },
            {
                field: "currencyDesc", headerName: "Para Birimi", width: 300,
                filterOperators: [createBooleanOperator(currencyDesc)],
            },
            { field: "bankCode", headerName: "Banka Kodu ", width: 300 },
            { field: "accountOwner", headerName: "Hesap Sahibi", width: 300 },
            { field: "iban", headerName: "İban", width: 300 },
            { field: "walletNo", headerName: "Cüzdan No", width: 200 },
        ];
    }, [deleteRow, showDelete]);

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);

        if (tableData) {
            const start = model.page * model.pageSize;
            const end = start + model.pageSize;

            setTableData(prev => ({
                ...prev,
                currentPage: model.page,
                pageSize: model.pageSize,
                totalPages: Math.ceil((prev?.result?.length || 0) / model.pageSize)
            }));
        }
    };

    const onSave = () => {

        const filterMerchantId = Array.isArray(getValues('filterMerchantId')) ? getValues('filterMerchantId') : getValues('filterMerchantId') ? [getValues('filterMerchantId') ?? 0] : [];

        const requestPayload = {
            page: 0,
            size: -1,
            orderBy: "CreateDate",
            paymentFlag: getValues("paymentFlag"),
            merchantId: filterMerchantId,
            orderByDesc: true,
            startPaymentMerchantDate: dayjs(getValues("startPaymentMerchantDate")).format("YYYY-MM-DD"),
            endPaymentMerchantDate: dayjs(getValues("endPaymentMerchantDate")).format("YYYY-MM-DD"),
            isExcel: true,
            ...getQueryParams(queryOptions),
        };

        if (getValues("startDate")) {
            requestPayload.startDate = dayjs(
                getValues("startDate")
            ).format("YYYY-MM-DD");
        }

        if (getValues("endDate")) {
            requestPayload.endDate = dayjs(
                getValues("endDate")
            ).format("YYYY-MM-DD");
        }
        if (queryOptions?.field && queryOptions?.value !== undefined) {
            requestPayload[queryOptions.field] = queryOptions.value;
        }

        GetMerchantPayment(requestPayload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    function fieldValue(data) {
                        return data.map((item) => {
                            return {
                                "Üye İşyeri Numarası": item?.merchantId,
                                "Üye İşyeri Adı": item?.merchantName,
                                "Ödenen Tutar": item?.paidAmount,
                                "Üye İşyeri Ödeme Tarihi": item?.paymentMerchantDate ? dayjs(item?.paymentMerchantDate).format("DD.MM.YYYY") : "",
                                "Üye İşyeri FTP Hak Ediş Tutarı": item?.paymentAmount,
                                "Üye İşyeri Cari Hak Ediş Tutarı": item?.paymentAmountBalance,
                                "Para Birimi": item?.currencyDesc,
                                "Banka Kodu": item?.bankCode,
                                "Hesap Sahibi": item?.accountOwner,
                                "İban": item?.iban,
                                "Cüzdan No.": item?.walletNo,
                                // "Gün Sonu Tarihi": item?.endOfDayDate,
                            };
                        });
                    }
                    const refactoredData = fieldValue(data?.data?.result);
                    downloadExcel(refactoredData || [], "İşyeri Hak Ediş Raporları");
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };
    const decimalFields = [
        'installmentCount', 'cardType',
        'paidAmount',
        'merchantCommissionAmount',
        'paymentAmount',
    ]

    const getQueryParams = (filters) => {
        const queryParams = {};

        for (let key in filters) {
            let value = filters[key];
            // Eğer gelen değer string "false" ise onu boolean false'a çevir
            if (value === "false") {
                queryParams[key] = false;
            } else if (key === "merchantId") {
                queryParams[key] = Array.isArray(value) ? value.map(Number) : [Number(value)];
            } else if (value !== null && value !== undefined && value.toString().length > 0) {
                if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
                    queryParams[key] = parseFloat(value).toFixed(2);
                } else {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };
    const keyRules = {
        'installmentCount': 1,
        'cardType': 1,
        'paidAmount': 1,
        'merchantCommissionAmount': 1,
        'paymentAmount': 1
    };

    const handleFilterChange = debounce((filters) => {
        if (filters.clearFilter) {
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);

        const isValueValid = (key, value) => {
            const minLength = keyRules[key] || 3;
            return value?.toString().length >= minLength;
        }


        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        // Eğer queryParams bir önceki ile aynıysa işlem yapma
        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
        }


        // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    // Komponent içerisinde
    const previousQueryParams = React.useRef({});

    // Payment Balance Hook
    const [balanceData, setBalanceData] = useState<any>(null);

    // const { mutate: getBalance, data: balanceData, isLoading: isBalanceLoading } = useGetListSettlementsPaymentBalance();

    const getBalance = (merchantPaymentData: any) => {
        setBalanceData(merchantPaymentData?.result2);
    }

    // Helper to calculate totals for cards
    const getBalanceByCurrency = (currency: string) => {
        if (!balanceData) return { paymentAmountBalance: 0, paymentAmount: 0, paidAmount: 0 };

        const filtered = balanceData.filter((item: any) => item.currencyDesc === currency);

        const paymentAmountBalance = filtered.reduce((sum: number, item: any) => sum + (item.paymentAmountBalance || 0), 0);
        const paymentAmount = filtered.reduce((sum: number, item: any) => sum + (item.paymentAmount || 0), 0);
        const paidAmount = filtered.reduce((sum: number, item: any) => sum + (item.paidAmount || 0), 0);

        return { paymentAmountBalance, paymentAmount, paidAmount };
    };

    const BalanceCard = ({ currency, label, color, iconSymbol, symbol, loading }) => {
        const { paymentAmountBalance, paymentAmount, paidAmount } = getBalanceByCurrency(currency);

        // Color mapping
        const colorMap = {
            green: { bg: '#22c55e', text: '#16a34a', border: '1px solid #dce0e5' },
            blue: { bg: '#3b82f6', text: '#2563eb', border: '1px solid #dce0e5' },
            red: { bg: '#ef4444', text: '#dc2626', border: '1px solid #dce0e5' }
        };
        const activeColor = colorMap[color];

        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
                borderRadius: '0.75rem',
                p: 1.5,
                bgcolor: 'background.paper',
                border: activeColor.border,
                boxShadow: 1,
                position: 'relative',
                overflow: 'hidden',
                '&:hover .icon-box': {
                    opacity: 0.2
                }
            }}>
                <Box className="icon-box" sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    p: 1.5,
                    opacity: 0.1,
                    transition: 'opacity 0.3s',
                    color: activeColor.text
                }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '2.5rem' }}>{iconSymbol}</span>
                </Box>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <div style={{ width: '0.5rem', height: '0.5rem', borderRadius: '9999px', backgroundColor: activeColor.bg }}></div>
                    <p style={{ color: '#637588', fontSize: '0.875rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{currency}</p>
                </div>

                {/* Cari Hak Ediş*/}
                <div>
                    <p style={{ fontSize: '0.75rem', color: '#637588' }}>Cari Hak Ediş Tutarı</p>
                    {loading ? <Skeleton variant="text" width="60%" height={32} /> : (
                        <p style={{ color: '#111418', fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.025em' }}>
                            {symbol}{paymentAmountBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </p>
                    )}
                </div>

                {/* FTP Hak Ediş && Ödenen Tutar */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: '0.25rem', borderTop: '1px solid #f0f0f0', paddingTop: '0.25rem' }}>
                    <div>
                        <p style={{ fontSize: '0.75rem', color: '#637588' }}>FTP Hak Ediş Tutarı</p>
                        {loading ? <Skeleton variant="text" width={80} /> : (
                            <p style={{ fontWeight: 600, color: '#111418', fontSize: '0.875rem' }}>
                                {symbol}{paymentAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        )}
                    </div>

                    <div style={{ width: 1, height: '24px', backgroundColor: '#e0e0e0', margin: '0 8px' }}></div>

                    <div>
                        <p style={{ fontSize: '0.75rem', color: '#637588' }}>Ödenen Tutar</p>
                        {loading ? <Skeleton variant="text" width={80} /> : (
                            <p style={{ fontWeight: 600, color: '#111418', fontSize: '0.875rem' }}>
                                {symbol}{paidAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        )}
                    </div>
                </div>
            </Box>
        );
    };

    // Removed isBalanceLoading from blocking loader
    const hasLoading = isGetMerchantPaymentLoading || isGetSendMoneyLoading || isMerchantListLoading;

    return (
        <>
            {hasLoading && <Loading />}
            <div>
                {/* Dialog bileşeni */}
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    PaperProps={{
                        style: {
                            width: '300px',
                            padding: 3
                        },
                    }}
                >
                    <DialogTitle className="customDialogTitle">Ödeme Onayı</DialogTitle>
                    <DialogContent >
                        <TextAreaInputControl
                            sx={{ marginTop: 2, width: '100%' }}
                            placeholder="Açıklama"
                            uniqueId="paymentDescriptionBulk"
                        />
                        <DialogContentText className="customDialogContent">
                            Ödemeyi onaylıyor musunuz?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmPay} color="primary" variant="contained" text="Evet">
                            Evet
                        </Button>
                        <Button onClick={handleCloseDialog} color="primary" variant="outlined" text="Hayır">
                            Hayır
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <Stack flex={1} justifyContent="space-between">
                <Stack flex={1} p={2}>

                    <Stack spacing={4}>

                        <Stack
                            spacing={1}
                            direction={isDesktop ? "row" : "column"}
                            sx={{
                                boxShadow: 'rgba(99, 99, 99, 0.1) 0px 2px 8px 0px',
                                border: 1,
                                borderColor: '#E0E0E0',
                                padding: 1.5,

                            }}
                        >
                            <FormControl sx={{ flex: 1 }}>
                                {merchantList && (
                                    <Controller
                                        control={control}
                                        name="filterMerchantId"
                                        render={({ field }) => (
                                            <Autocomplete
                                                multiple
                                                id="merchant-multi-checkbox"
                                                options={merchantList}
                                                disableCloseOnSelect
                                                getOptionLabel={(option) => `${option.label} ( ${option.value} )`}
                                                getOptionDisabled={(option) => option.isPayoutBlocked}
                                                onChange={(event, newValue) => {
                                                    // Seçilen tüm değerlerin dizisini güncelliyoruz
                                                    field.onChange(newValue.map((item) => item.value));
                                                }}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props} key={option.value}>
                                                        <Checkbox
                                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.label} ( {option.value} )
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                <Controller
                                    name="paymentFlag"
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <FormControl component="fieldset" fullWidth sx={{ ml: 2 }}>
                                            <FormLabel component="legend">
                                                Ödeme Yapıldı mı?
                                            </FormLabel>
                                            <RadioGroup
                                                aria-label="paymentFlag"
                                                name="paymentFlag"
                                                value={value}
                                                onChange={(e) => onChange(e.target.value === "true")}
                                                row
                                            >
                                                <FormControlLabel
                                                    value="true"
                                                    control={<Radio />}
                                                    label="Evet"
                                                />
                                                <FormControlLabel
                                                    value="false"
                                                    control={<Radio />}
                                                    label="Hayır"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                                />
                            </FormControl>

                            <Button
                                onClick={handleSubmit(onSubmit)}
                                variant="contained"
                                sx={{
                                    minWidth: '120px'
                                }}
                                text={"ARA"}
                            />
                        </Stack>
                    </Stack>

                    <Stack flex={1} mt={2} spacing={2}>
                        {showTable && (
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : '1fr', gap: '1rem' }}>
                                <BalanceCard currency="TRY" label="TRY Payable" color="red" iconSymbol="₺" symbol="₺" loading={hasLoading} />
                                <BalanceCard currency="USD" label="USD Payable" color="green" iconSymbol="$" symbol="$" loading={hasLoading} />
                                <BalanceCard currency="EUR" label="EUR Payable" color="blue" iconSymbol="€" symbol="€" loading={hasLoading} />
                            </div>
                        )}
                        <>
                            {showTable && (
                                <Table

                                    className="merchantEndOfDayTable"
                                    hasActiveFilters={hasActiveFilters}
                                    handleFilterChange={handleFilterChange}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={handleChangePagination}
                                    rowCount={tableData?.totalItems ?? 0}
                                    getRowId={(row) => row.uniqueId}
                                    disableRowSelectionOnClick
                                    pagination
                                    paginationMode="client"
                                    handleBulkPay={handleBulkPay}
                                    sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
                                    isRowSelectable={(params) => {
                                        // Only allow selection if balance is 0 or currency is not TRY
                                        return (params.row.paymentAmountBalance > 0 && params.row.currencyDesc === 'TRY');
                                    }}
                                    checkboxSelection
                                    onRowSelectionModelChange={(ids) => {
                                        const selectedIDs = new Set(ids);
                                        const newSelectedRows = tableData?.result.filter((row) => {
                                            if (!(row.paymentAmountBalance > 0 && row.currency == '949')) {
                                                return false;
                                            }
                                            return selectedIDs.has(row.uniqueId);
                                        });
                                        setSelectedRows(newSelectedRows);
                                    }}
                                    openDialog={(val) => {
                                        setPaymentMode('selected');
                                        setOpenDialog(val);
                                    }}
                                    extraLeftButtons={
                                        <Button
                                            startIcon={<MonetizationOnIcon />}
                                            onClick={() => {
                                                setPaymentMode('page');
                                                setOpenDialog(true);
                                            }}
                                            disabled={!tableData?.result?.some(row => row.paymentAmountBalance > 0 && row.currencyDesc === 'TRY')}
                                            sx={{ marginLeft: 2 }}
                                            variant="text"
                                            text="Sayfayı Öde"
                                        />
                                    }
                                    selectedRows={selectedRows}
                                    showBulkPayButton={true}
                                    rows={tableData?.result || []}
                                    autoHeight={!isDesktop}
                                    customLabelDisplayedRows={true}
                                    columns={columns}
                                    exportFileName="İşyeri Hak Ediş Raporları"
                                    onSave={() => onSave()}
                                />
                            )}

                        </>

                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}